import { useTranslation } from 'react-i18next';
import { THEME, TK_ACCOUNT_IS_CREATED_LESS_THAN_1_DAY } from '@anytag/shared-constants';
import { SimilarInfluencersTemplate, WidgetSelectButtonProps } from '../../shared';
import { RefetchSimilarInfluencersVariables } from '../../schemaTypes';
import { useTiktokSimilarInfluencersList } from '../hooks';
import { TiktokInfluencerProfile } from '../schemaTypes';
import { ProfileWidget } from './ProfileWidget';

interface SimilarInfluencersListProps {
  socialAccountId: number;
  isSectionOpened: boolean;
  getListSelectButtonProps?: (influencer: TiktokInfluencerProfile) => WidgetSelectButtonProps;
}

export const SimilarInfluencersList = ({
  socialAccountId,
  isSectionOpened,
  getListSelectButtonProps
}: SimilarInfluencersListProps) => {
  const { t } = useTranslation();
  const { limit, error, loading, totalRecords, listRecords, onFetchData, onRefetchData } =
    useTiktokSimilarInfluencersList({ socialAccountId });

  const handleRefetchData = async (variables: RefetchSimilarInfluencersVariables) => {
    await onRefetchData?.(variables);
  };

  return (
    <SimilarInfluencersTemplate
      loading={loading}
      fetchLimit={limit}
      onFetchData={onFetchData}
      totalRecords={totalRecords}
      onRefetchData={handleRefetchData}
      isSectionOpened={isSectionOpened}
      errorMessage={
        error?.message === TK_ACCOUNT_IS_CREATED_LESS_THAN_1_DAY
          ? t<string>('Similar accounts will be shown in 1-2 days after being added to AnyTag')
          : ''
      }
    >
      {({ currentLimit }) =>
        listRecords
          .slice(0, currentLimit)
          .map((profile, index) => (
            <ProfileWidget
              profile={profile}
              key={`similar-influencer-${profile.id}_${index}`}
              selectButtonProps={getListSelectButtonProps?.(profile)}
              css={{ boxShadow: 'none', backgroundColor: THEME.background.colors.gray.lv1 }}
            />
          ))
      }
    </SimilarInfluencersTemplate>
  );
};
